module.exports = __webpack_public_path__ + "static/img/event2.7294b96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popup/concierge/20250717/event2.png
// module id = rYwD
// module chunks = 0